import React, {useEffect, useImperativeHandle, useRef, useState} from "react";
import {
  Tabs,
TabsProps,
} from "antd";
// import { Tabs} from "components/common";

import {useAppDispatch, useAppSelector} from "../../../../../../redux/hooks";
import {tabKeys} from "../../../../../../types/enums";
import Tab1 from "./Tab1/Tab1";
import Tab2 from "./Tab2/Tab2";
import { setActiveKey } from "redux/reducer/common";
const FormAdd = (props) => {
  const modalRef = useRef<any>();
  const { data, closeModal, type, getListApi, loading, setCurrentPage } = props;
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector((state) => state.common.activeTab);
  
  const handleModalClose = () => {
    // Explicitly set activeTab to LIST_TRAINING after closing the modal
    // dispatch(setActiveKey(tabKeys.TRAINING.LIST_TRAINNING));
  };
  if (type === "Thêm") {
    const items: TabsProps["items"] = [
      {
        key: tabKeys.MODAL_TRAINING.TAB_1,
        label: `Thông tin khóa đào tạo `,
        children: (
          <Tab2
            data={data}
            getListApi={getListApi}
            type={type}
            setCurrentPage={null}
            closeModal={closeModal}
          />
        ),
      },
    ];
    return (
      <div className="employee-directory page">
        <div className="main">
          <Tabs items={items} />
        </div>
      </div>
    );
  } else {
    const items: TabsProps["items"] = [
      {
        key: tabKeys.MODAL_TRAINING.TAB_1,
        label: `Thông tin khóa đào tạo `,
        children: (
          <Tab2
            data={data}
            getListApi={getListApi}
            type={type}
            setCurrentPage={null}
            closeModal={closeModal}
          />
        ),
      },
      {
        key: tabKeys.MODAL_TRAINING.TAB_2,
        label: `Danh sách nhân viên tham gia đào tạo  `,
        children: (
          <Tab1
            data={data}
            getListApi={getListApi}
            type={type}
            setCurrentPage={null}
            closeModal={closeModal}
          />
        ),
      },
    ];
    return (
      <div className="employee-directory page">
        <div className="main">
          <Tabs items={items} />
        </div>
      </div>
    );
  }
};

export default FormAdd;
